<template>
	<div>
    <label class="typo__label">Custom option template</label>
    <multiselect v-model="value" placeholder="Fav No Man’s Sky path" label="title" track-by="title" :options="options" :option-height="120" :custom-label="customLabel" :show-labels="false">
      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <span class="option__title">{{ props.option.hname }}</span>
          <span class="option__small">{{ props.option.hno }}</span>
          <span class="option__small">{{ props.option.phone }}</span>
        </div>
      </template>
      <span slot="noResult">暂无搜索结果</span>
    </multiselect>
    <!-- <pre class="language-json"><code>{{ value }}</code></pre> -->
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import { expire } from '@/utils/auth'

export default {
  components: {
    Multiselect
  },
  data () {
    return {
      value: { hname: 'Explorer', hno: 'Discovering new species!', phone: '454645132121', img: 'static/posters/creatures.png' },
      options: [
        { hname: 'Space Pirate', hno: 'h45', phone: '13411997525', img: 'static/posters/fleet.png' },
        { hname: 'Merchant', hno: '55', phone: '145254552', img: 'static/posters/trading_post.png' },
        { hname: 'Explorer', hno: '88', phone: '555242152', img: 'static/posters/creatures.png' },
        { hname: 'Miner', hno: '132', phone: '1321654520', img: 'static/posters/resource_lab.png' }
      ]
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  methods: {
    customLabel ({ hname, hno, phone }) {
      return `${hname} – ${hno} - ${phone}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// testMultSelect.vue?2036f8d6